import { render, staticRenderFns } from "./PortalHelp.vue?vue&type=template&id=6150ac06&scoped=true"
import script from "./PortalHelp.vue?vue&type=script&lang=js"
export * from "./PortalHelp.vue?vue&type=script&lang=js"
import style0 from "./PortalHelp.vue?vue&type=style&index=0&id=6150ac06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6150ac06",
  null
  
)

export default component.exports